<div class="label label-{{ status }}">{{ statusText ? statusText : (status | titlecase) }}</div>